import React from 'react';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  danger = false, onConfirm, onCancel,
}: ConfirmModalProps) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 300,
      background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem',
      animation: 'fadeIn 0.15s ease',
    }} onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div style={{
        background: 'linear-gradient(135deg, var(--baize), var(--felt))',
        border: `2px solid ${danger ? 'rgba(192,57,43,0.5)' : 'rgba(201,168,76,0.35)'}`,
        borderRadius: '14px',
        padding: 'clamp(1.5rem,5vw,2rem)',
        width: '100%', maxWidth: '420px',
        boxShadow: '0 24px 64px rgba(0,0,0,0.6)',
        animation: 'slideUp 0.2s ease',
      }}>
        {/* Icon */}
        <div style={{ fontSize: '2rem', marginBottom: '0.75rem', textAlign: 'center' }}>
          {danger ? '⚠️' : '❓'}
        </div>

        {/* Title */}
        <h2 style={{
          fontFamily: 'Bebas Neue', fontSize: '1.6rem', lineHeight: 1,
          color: danger ? '#e74c3c' : 'var(--gold)',
          marginBottom: '0.75rem', textAlign: 'center',
        }}>
          {title}
        </h2>

        {/* Message */}
        <p style={{
          color: 'var(--chalk-dim)', fontSize: '0.88rem', lineHeight: 1.6,
          marginBottom: '1.5rem', textAlign: 'center',
        }}>
          {message}
        </p>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button onClick={onCancel} style={{
            flex: 1, padding: '0.75rem',
            background: 'transparent', color: 'var(--chalk-dim)',
            border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px',
            fontSize: '0.88rem', fontWeight: 600, cursor: 'pointer', minHeight: '44px',
          }}>
            {cancelLabel}
          </button>
          <button onClick={onConfirm} style={{
            flex: 1, padding: '0.75rem',
            background: danger
              ? 'rgba(192,57,43,0.2)'
              : 'linear-gradient(135deg, var(--gold), var(--gold-light))',
            color: danger ? '#e74c3c' : 'var(--baize-dark)',
            border: danger ? '1px solid rgba(192,57,43,0.5)' : 'none',
            borderRadius: '8px', fontSize: '0.88rem', fontWeight: 700,
            cursor: 'pointer', minHeight: '44px',
          }}>
            {confirmLabel}
          </button>
        </div>
      </div>
      <style>{`
        @keyframes fadeIn  { from{opacity:0} to{opacity:1} }
        @keyframes slideUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
      `}</style>
    </div>
  );
}
